module.exports = __webpack_public_path__ + "img/shareCover.65f747d4.png";